<template>
  <el-dialog
    :visible.sync="visible"
    top="0"
    custom-class="cost-dialog"
    :before-close="handleClose"
    :append-to-body="true"
    :modal-append-to-body="false"
    :close-on-click-modal="false"
    width="420px"
    center
  >
    <!-- <div slot="title" class="dialog-title tabheader">
      <span>提示</span>
    </div> -->
    <div class="dialog-body">
      <div class="title">提示</div>
      <div class="content" v-if="!isPayed">
        {{ payTipText }}
      </div>
      <div class="content" v-else>
        {{
          canRepeatDownload
            ? "亲爱的用户，使用通享卡抵扣过的资料，365天内可以免费重复下载"
            : "亲爱的用户，您已使用通享卡抵扣过该资源，365天内可直接在线预览，无需重复支付"
        }}
      </div>
      <div class="tip" v-if="isPayed && canRepeatDownload">
        本次下载不消耗通享卡余额
      </div>
      <div class="cost-money" v-if="!isPayed">
        <div class="cost-num">
          余额抵扣：<span>{{ payment.toFixed(2) }}元</span>
        </div>
        <div class="save-num">
          {{ isPackageSale ? "成套专辑价格" : "节省" + saveMoney + "元" }}
        </div>
      </div>
      <div
        class="balance-money"
        v-if="userInfo && userInfo.resourceCardVO && !isPayed"
      >
        学科网通享卡-{{
          userInfo.resourceCardVO.schoolChargeUsedType == 1
            ? "学校共享"
            : "个人"
        }}余额：{{ userInfo.resourceCardVO.resourceCardBalance.toFixed(2) }}元
      </div>
    </div>

    <div slot="footer" class="dialog-footer">
      <div
        class="btn"
        v-if="!isPayed || !canRepeatDownload"
        data-io-click="tracker"  @click="handleClose"
        round
      >
        取消
      </div>
      <div
        class="btn"
        data-io-click="tracker"  @click="handleSubmit"
        type="info"
        :class="['submit info']"
      >
        {{ isPayed && canRepeatDownload ? "再次下载" : "确定" }}
      </div>
    </div>
  </el-dialog>
</template>

<script>
import { mapState } from "vuex";
const CURRENTCOURSE = "CURRENTCOURSE";
export default {
  mixins: [],
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    documentId: {
      type: Number,
      default: null,
    },
    data: {
      type: Array,
      default: () => [],
    },
    costInfoKey: {
      type: String,
      default: "",
    },
    // 支付类型 1是下载 2是备课 3是编辑
    type: {
      type: Number,
      default: 1,
    },
    isPackageSale: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isPayed: false,
      payment: 0,
      saveMoney: 0,
      canRepeatDownload: false,
    };
  },
  watch: {
    // payment:{
    //   hander(newVal,oldVal){
    //     if(!newVal){
    //       console.log()
    //     }
    //   },
    // }
    data: {
      handler(val, oldVal) {
        // console.log("val----", val, oldVal);
        if (val && val.length) {
          let paymentTotalMoney = 0;
          let saveTotalMoney = 0;
          let canDownloadItem = false;
          val.forEach((item) => {
            if (
              item.payInfoVO &&
              item.payInfoVO.payType == 2 &&
              !item.hasDownload
            ) {
              paymentTotalMoney += item.payInfoVO.payment;
              saveTotalMoney += item.payInfoVO.saveMoney;
            }
          });
          canDownloadItem = val.find((item) => !item.isDisableDownLoad);
          console.log("canDownloadItem", canDownloadItem);

          // if (!paymentTotalMoney) {
          // 已经支付过了
          // console.log("已经支付过了");
          this.isPayed = !paymentTotalMoney;
          this.payment = paymentTotalMoney;
          this.saveMoney = saveTotalMoney;
          this.canRepeatDownload = !!canDownloadItem;
        }
      },
    },
  },
  computed: {
    ...mapState({
      userInfo: "userInfo",
    }),
    payTipText() {
      return this.userInfo.resourceCardVO &&
        this.userInfo.resourceCardVO.resourceCardBalance < this.payment
        ? "亲爱的用户，当前卡内金额不足，请联系学校管理员充值"
        : "亲爱的用户，请您确认本次余额抵扣的金额情况";
    },
    // payment(){
    //   return totalMoney
    // },
    // saveMoney(){
    //   let totalMoney = 0;
    //   this.data && this.data.forEach(item=>{
    //     if(item.payInfoVO && item.payInfoVO.payType == 2 && !item.hasDownload){
    //       totalMoney+= item.payInfoVO.saveMoney;
    //     }
    //    })
    //   return totalMoney
    // }
  },
  components: {},
  mounted() {},
  methods: {
    handleClose() {
      if (event) {
        event.stopPropagation();
      }
      this.$emit("handleClose");
    },
    handleSubmit() {
      this.userInfo.resourceCardVO.resourceCardBalance >= this.payment &&
        this.canRepeatDownload &&
        this.$emit("handleSubmit", {
          costInfoKey: this.costInfoKey,
          type: this.type,
          isPayed: this.isPayed,
          payment: this.payment,
          isPackageSale: this.isPackageSale,
        });
      // console.log(
      //   this.userInfo.resourceCardVO.resourceCardBalance >= this.payment,
      //   this.payment,
      //   this.canRepeatDownload
      // );
      this.userInfo.resourceCardVO.resourceCardBalance >= this.payment &&
        this.payment &&
        !this.canRepeatDownload &&
        this.$emit("finallyPay", {
          costInfoKey: this.costInfoKey,
          isPayed: this.isPayed,
          payment: this.payment,
          isPackageSale: this.isPackageSale,
        });
      this.handleClose();
    },
  },
};
</script>
<style scoped lang="scss">
::v-deep .cost-dialog {
  // background-color: #D9D9D9;
  background: url("../assets/images/resource-card/card-bg.png") no-repeat top
    center;
  height: 235px;
  background-size: 100% 100%;
  .el-dialog__header {
    border-bottom: none !important;
    height: auto;
    .el-dialog__close {
      color: #582d00;
      font-weight: bold;
    }
  }
  .el-dialog__body {
    // padding: 0 20px;
    height: auto;
    .dialog-body {
      padding: 0 24px;
      .title {
        color: #c18e51;
        text-align: left;
        font-size: 18px;
        margin-top: 5px;
        margin-bottom: 4px;
      }
      .content {
        color: #582d00;
        font-size: 14px;
      }
      .tip {
        margin-top: 20px;
        color: #f95633;
        font-size: 14px;
      }
      .cost-money {
        margin-top: 24px;
        display: flex;
        align-items: center;
        margin-bottom: 4px;
        .cost-num {
          color: #f95633;
          font-size: 14px;
          display: flex;
          align-items: center;
          span {
            font-size: 22px;
          }
        }
        .save-num {
          margin-left: 14px;
          line-height: 20px;
          border: 1px solid #c18e51;
          border-radius: 4px;
          padding: 0 10px;
          color: #c18e51;
          height: 20px;
          font-size: 12px;
          display: flex;
          align-items: center;
        }
      }
      .balance-money {
        color: #7e7e7e;
        font-size: 14px;
      }
    }
  }
  .el-dialog__footer {
    padding: 0 20px;
  }
  .dialog-footer {
    display: flex;
    margin-top: 24px;
    align-items: center;
    justify-content: flex-end;
    position: absolute;
    bottom: 20px;
    right: 20px;
    width: 100%;
    .btn {
      width: 64px;
      height: 32px;
      font-size: 14px;
      line-height: 30px;
      border-radius: 6px;
      color: #7e7e7e;
      border: 1px solid #7e7e7e;
      text-align: center;
      cursor: pointer;
      &.submit {
        width: auto;
        padding: 0 16px;
        border: none;
        color: #582d00;
        margin-left: 24px;
        background: linear-gradient(90deg, #eed4a3 0%, #d8ab67 100%);
      }
    }
  }
}
</style>
